import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ucWordsPipe'
})
export class UcWordsPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return value ? value.upperCaseFirst() : '';
  }

}
